<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-12-27 10:20:54
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-12-27 10:43:08
 * @FilePath: /chaoyongtuan/src/views/shopManage/tagManagement/components/tableCell/goodsNum.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="goods-num">
		<el-link type="primary" @click="skipUrl(row)">{{ row.tag_use_count }}</el-link>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
	components: {},
	computed: {},
	data() {
		return {};
	},
	methods: {
		skipUrl({ id, tag_name }) {
			let handLink = this.$router.resolve({
				path: '/shopManage/shopLibrary/list',
				query: {
					id,
					tag_name,
				},
			});
			window.open(handLink.href, '_blank');
		},
	},
};
</script>
<style lang="less" scoped></style>
